// extracted by mini-css-extract-plugin
module.exports = {"curatedPagesItem":"styles_curatedPagesItem__6mwbH","image":"styles_image__uv4u9","content":"styles_content__tsoXc"};